import { Consent } from './Consent'
import { withConsent } from './withConsent'

const ConnectedConsent = withConsent(Consent)
export { ConnectedConsent as Consent }
